module.exports = __webpack_public_path__ + "img/truewallet.c3b7e4a6.png";